import { useQuery } from '@tanstack/react-query';

import { getOwnBusiness } from '../api/endpoints/businesses';
import type { BusinessDetail } from '../api/schemas';
import { useSession } from '../auth/useSession';

const BUSINESS_STALE_MS = 5 * 60 * 1000;

/**
 * The session's own business detail (name, services, staff). Catalog data
 * moves slowly, so one fetch serves the whole shell for a while.
 */
export function useBusiness(): BusinessDetail | undefined {
  const { session } = useSession();
  const businessId = session?.businessId;
  const query = useQuery({
    queryKey: ['business-detail', businessId],
    queryFn: getOwnBusiness,
    enabled: Boolean(businessId),
    staleTime: BUSINESS_STALE_MS,
  });
  return query.data;
}

/** Resolves a service id to its human name; falls back to the id untranslated. */
export function serviceName(business: BusinessDetail | undefined, serviceId: string): string {
  const service = business?.services.find((entry) => entry.id === serviceId);
  return service?.name ?? serviceId;
}

/** A roster entry's display name, for the coach shell; undefined until the business loads. */
export function staffName(business: BusinessDetail | undefined, staffId: string | null | undefined): string | undefined {
  if (!staffId) return undefined;
  return business?.staff.find((entry) => entry.id === staffId)?.name;
}
